export default {
  state: {
    availableDrivers: {
      list: [],
      selected: '',
      loading: false
    }
  },
  mutations: {
    setAvailableDriversData (state, data) {
      for (let field in data) {
        state.availableDrivers[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/dispatch/available-drivers.js